/**
 * Parcel.js doesn't seem to like our "exports" field
 * in the package.json so we have to do this.
 */
module.exports = require('./dist/react/index');
